var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBeginner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 1.875H4.625C3.52043 1.875 2.625 2.77043 2.625 3.875V13.5M5.25 1.875V9L6.09601 8.49239C6.72937 8.11238 7.52063 8.11238 8.15399 8.49239L9 9V1.875M5.25 1.875H9M9 1.875H13.375C14.4796 1.875 15.375 2.77043 15.375 3.875V13.5M2.625 13.5V14.125C2.625 15.2296 3.52043 16.125 4.625 16.125H13.375C14.4796 16.125 15.375 15.2296 15.375 14.125V13.5M2.625 13.5H15.375",
    stroke: "#363A44",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBeginner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/beginner.c4c60f301e8b1beae47d38d71d6825be.svg";